<vo-vm-theme-provider>
  <div *ngIf="content" class="vm-container cozy">
    <div class="vm-row">
      <div class="vm-col-xs-12">
        <div class="title" *ngIf="content?.title">
          <h1 vo-text [size]="'T600'" [weight]="'medium'">{{ content?.title }}</h1>
        </div>

        <div class="copy" *ngIf="content?.info">
          <div vo-text [size]="'T300'" [weight]="'regular'">
            <markdown [disableSanitizer]="true" ngPreserveWhitespaces>
              {{ content?.info }} 
            </markdown>
            <a vo-anchor voAlertTextLink variant="primary" (click)="openModal()" [type]="'standalone'" #modalFocus>Let us help</a>

            <vo-modal
              *ngIf="isModalOpen"
              [label]="content?.secondaryModalLabel"
              [returnFocusTo]="modalFocus"
              (dismiss)="closeModal()">
              <markdown ngPreserveWhitespaces>
                {{ content.secondaryModalCopy }}
              </markdown>
            </vo-modal>
          </div>
        </div>

        <div class="tile-container">
          <div class="vm-row">
            <div class="vm-col-md-4" *ngFor="let tile of content.tiles">
              <div class="bdr tile">
                <div *ngIf="tile?.iconSrc && !tile?.icon" class="tile-img">
                  <img [src]="strapiUrl + tile?.iconSrc?.url" [alt]="tile?.alt" />
                </div>

                <div class="tile-inner-heading" *ngIf="tile?.title">
                  <h4 vo-text [size]="'T500'" [weight]="'regular'">{{ tile?.title }}</h4>
                </div>
                <div class="button-container">
                  <button
                    vo-button
                    vmGtmCta
                    (click)="selectTVBox(tile?.url, tile?.uid)"
                    [variant]="'tertiary'"
                    [decoration]="'solid'"
                    [layout]="'full-width'">
                    {{ tile?.label }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</vo-vm-theme-provider>
